import React, {Fragment, useState} from 'react'
import {Spin} from 'antd'
import TableHead from './data/TableHead'
import TableRow from './data/TableRow'
import emptyData from '../../../assets/images/empty-img-gray.png'
import SettingShippingRulePagination from "./SettingShippingRulePagination"

const SettingShippingRuleTable = (props) => {
    const {loading, shippingRules, platforms} = props
    const [loadingSend, _setLoadingSend] = useState(false)

    return (
        <div className="ShippingRuleTable">
            <Spin spinning={loading} tip='Loading...'>
                {shippingRules.length > 0 ? (
                    <div>
                        <table className='table'>
                            <TableHead/>
                            <tbody className="TableBody">
                            {
                                shippingRules.map(shippingRule => {
                                    return (
                                        <Fragment key={shippingRule._id}>
                                            <TableRow
                                                platforms={platforms}
                                                loadingSend={loadingSend}
                                                handleSendLoading={_setLoadingSend}
                                                shippingRule={shippingRule}
                                                currentPage={1}
                                            />
                                        </Fragment>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        <SettingShippingRulePagination {...props}/>
                    </div>
                ) : !loading && (
                    <div className="noData d-flex flex-column align-items-center justify-content-center">
                        <img src={emptyData} alt="No data"/>
                        No data!
                    </div>
                )}
            </Spin>
        </div>
    )
}

export default SettingShippingRuleTable
